import config from ':cloud/config';
import useHasExperiment from ':cloud/hooks/useHasExperiment';

export function useIsOnWaasConsumerAllowlist() {
  return useHasExperiment('mar_2024_waas_consumer', 'treatment') || !config.isProduction();
}
